import {Button} from '@wandb/weave/components/Button';
import {Icon} from '@wandb/weave/components/Icon';
import React, {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {twMerge} from 'tailwind-merge';

import {fixView as fixViewAction} from '../../state/workspaces/actions';
import {useTrackWorkspaceError} from './utils';
import {WorkspaceError} from './WorkspaceErrorContent';

export const WorkspaceResetContent = ({
  workspaceStateId,
  viewType,
}: {
  workspaceStateId: string;
  viewType: 'project-view' | 'sweep-view' | 'group-view' | 'run-view';
}) => {
  const dispatch = useDispatch();
  const fixView = useCallback(
    () => dispatch(fixViewAction(workspaceStateId)),
    [dispatch, workspaceStateId]
  );
  const trackWorkspaceError = useTrackWorkspaceError({
    action: 'Reset workspace',
    errorType: 'Error boundary',
    viewType,
  });

  return (
    <WorkspaceError
      title="Unable to render panels"
      header={
        <div
          className={twMerge(
            'mb-16 h-[80px] w-[80px] shrink-0 rounded-full',
            'bg-moon-550/[.1] text-moon-550',
            'flex items-center justify-center'
          )}>
          <Icon name="warning" width={34} height={34} />
        </div>
      }>
      <div className="text-wrap mt-4 w-[600px] text-center text-lg leading-[140%]">
        <p>
          There was an error rendering panels in your workspace. Try resetting
          it.
        </p>
        <p>This preserves runs but custom charts will be lost.</p>
      </div>
      <Button
        className="mt-16"
        onClick={() => {
          fixView();
          trackWorkspaceError();
        }}>
        Reset my workspace
      </Button>
    </WorkspaceError>
  );
};
